export default __webpack_public_path__ + "static/media/googlestore.3e114bc6.svg";